import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { apiAction, generalSet } from '../../store/generalSlice';

const CreateDuplicateDiffAccount = () => {
  const dispatch = useDispatch();
  const actionType = 'DUPLICATE_DIFF_ACCOUNT';
  const { actionCreatedDuplicateDiffAccount, actionCreatedDuplicateDiffAccountLoading } = useSelector(
    (state) => state.general
  );
  const [actionData, setActionData] = useState({});

  if (actionCreatedDuplicateDiffAccount?._id) {
    dispatch(generalSet({ reduxField: 'actionCreatedDuplicateDiffAccount', value: {} }));
    window.location.href = '/actions';
  }

  return (
    <>
      <div>
        <Link to='/CreateAction' className='btn btn-outline-dark'>
          Change Action Type
        </Link>
      </div>
      <div className='container mt-4' data-aos='fade-up' data-aos-delay='200'>
        <div className='row d-flex justify-content-center border-bottom'>
          <h1>
            Create Action: <span className='text-primary'>Duplicate Diff Account</span>
          </h1>
        </div>
        <div className='row d-flex justify-content-center mt-4'>
          <div className='col-md-6'>
            <input
              type='text'
              className='form-control'
              placeholder='Action name...'
              style={{ textAlign: 'center' }}
              onChange={(e) => setActionData({ ...actionData, name: e.target.value })}
            />
          </div>
        </div>
        {actionData.name ? (
          <>
            <div className='row d-flex justify-content-center mt-4' data-aos='fade-up' data-aos-delay='200'>
              <button
                className='btn btn-outline-primary'
                disabled={actionCreatedDuplicateDiffAccountLoading}
                onClick={() => {
                  dispatch(generalSet({ reduxField: 'actionCreatedDuplicateDiffAccountLoading', value: true }));
                  dispatch(
                    apiAction({
                      route: 'actions/createAction',
                      reduxField: 'actionCreatedDuplicateDiffAccount',
                      actionType,
                      actionData,
                      setLoading: 'actionCreatedDuplicateDiffAccountLoading',
                    })
                  );
                }}
              >
                Create Action
              </button>
            </div>
          </>
        ) : null}
      </div>
    </>
  );
};

export default CreateDuplicateDiffAccount;
